import { render, staticRenderFns } from "./VocabularyTraining.vue?vue&type=template&id=b8bb2e50&scoped=true&"
import script from "./VocabularyTraining.vue?vue&type=script&lang=js&"
export * from "./VocabularyTraining.vue?vue&type=script&lang=js&"
import style0 from "./VocabularyTraining.vue?vue&type=style&index=0&id=b8bb2e50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8bb2e50",
  null
  
)

export default component.exports